import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, UrlTree } from '@angular/router';
import { Store } from '@ngrx/store';
import { selectCurrentUserProfile } from '@libs/store';
import { routes } from '@libs/utils';
import { Observable, filter, map, take } from 'rxjs';

/** Lets only site admins of the site in the URL through; everyone else goes back to the site. */
export const SiteAdminGuard: CanActivateFn = (route: ActivatedRouteSnapshot): Observable<boolean | UrlTree> => {
  const router = inject(Router);
  const siteId = route.pathFromRoot.map((snapshot) => snapshot.paramMap.get('siteId')).find((id) => !!id);

  // Wait for the profile: on a hard refresh the store starts empty.
  return inject(Store)
    .select(selectCurrentUserProfile)
    .pipe(
      filter((profile): profile is NonNullable<typeof profile> => !!profile),
      take(1),
      map((profile) => {
        const site = profile.sites.find((userSite) => userSite.id === siteId);
        const isSiteAdmin = !!(site?.provider?.isAdmin || site?.staff?.isAdmin);

        return isSiteAdmin || router.createUrlTree(siteId ? [routes.site, siteId] : ['/']);
      }),
    );
};
